import * as React from 'react';

export interface BackButtonConfig {
  to: string;
  title: string;
}

export interface BackButtonContextValues {
  backButton: BackButtonConfig;
  isShown: boolean;
}

export interface BackButtonContextState extends BackButtonContextValues {
  setBackButton: (newBackButton?: BackButtonConfig | undefined) => void;
}

export const BackButtonContext = React.createContext<BackButtonContextState>({
  backButton: {
    title: 'Back',
    to: '/',
  },
  isShown: false,
  setBackButton: () => null,
});
